import { combineEpics } from 'redux-observable';
import { createDataSourceEpicReducer } from '../ducks/DataSourceCreate.ducks';
export default combineEpics(createDataSourceEpicReducer.epic);

//# sourceMappingURL=DataSourceCreateEpic.js.map
